import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

function CompanyCardSkeleton() {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Stack direction="column" alignItems="center" spacing={1.5}>
          <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: "12px" }} />
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="85%" height={18} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function CompanySelectionSkeleton({ count = 6 }: { count?: number }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
        gap: 2,
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <CompanyCardSkeleton key={i} />
      ))}
    </Box>
  );
}
